// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__144u3","question":"styles_question__1Jxy7","description":"styles_description__1q2ap"};